import FranziskaDecker from "../../../../images/content/introduction/applia-secretariat/FranziskaDecker.webp";
import KorrinaHegarty from "../../../../images/content/introduction/applia-secretariat/KorrinaHegarty.webp";
import ClemenceRazzano from "../../../../images/content/introduction/applia-secretariat/ClemenceRazzano.webp";

export const AppliaSecretariatMembersTeam4 = [
	{
		name: "Korrina Hegarty",
		imageUrl: KorrinaHegarty,
		background: "pages.introduction.appliaSecretariat.members.korrinaHegarty.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.korrinaHegarty.functionTitle",
	},
	{
		name: "Franziska Decker",
		imageUrl: FranziskaDecker,
		background: "pages.introduction.appliaSecretariat.members.franziskaDecker.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.franziskaDecker.functionTitle",
	},
	{
	name: "Clémence Razzano",
		imageUrl: ClemenceRazzano,
		background: "pages.introduction.appliaSecretariat.members.clemenceRazzano.background",
		functionTitle: "pages.introduction.appliaSecretariat.members.clemenceRazzano.functionTitle",
	},
];
